<template>
  <div>
    <div v-if="memberType">
      <img
        v-if="memberType == 1 || memberType == 3"
        src="@/assets/img/nei.png"
        alt=""
        class="banner"
      />
      <img v-else src="@/assets/img/wai.png" alt="" class="banner" />
    </div>
    <div v-else class="banner"></div>
    <div class="bodyControll">
      <div class="contentControll">
        <div class="menuControll">
          <Menu />
        </div>
        <div class="mainControll">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import { mapState } from "vuex";
import { enterprise } from "@/api/company.js";

export default {
  name: "home",
  data() {
    return {
      memberType: null, //类型
    };
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  async created() {
    // 下面判断如果登录信息失效，就直接跳登录页
    try {
      const res = await enterprise();
      console.log(typeof res);
      // console.log(res.member_type, "res.member_type");
      this.memberType = res.member_type;
    } catch (error) {
      this.$router.push({
        name: "login",
      });
    }
  },
  components: {
    Menu,
  },
};
</script>

<style lang="less" scoped>
.banner {
  width: 1200px;
  height: 60px;
  border-radius: 2px;
  display: block;
  margin: auto;
  margin-top: 30px;
}

.bodyControll {
  margin: auto;
  width: 1200px;
  margin-top: 30px;

  .contentControll {
    display: flex;
    margin-top: 20px;

    .menuControll {
      width: 200px;
      height: 780px;
      background: #ffffff;
      border-radius: 2px;
    }

    .mainControll {
      flex: 1;
      width: 980px;
      border-radius: 2px;
      margin-left: 20px;
    }
  }
}
</style>
